import { useGetOrganization, OrganizationDto } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';
import { env } from '@sib/config';

const ASK_AI_ENDPOINT = '/ask-ai';

const generateAskAiUrl = (organization?: OrganizationDto): string => {
  const port = organization?.aiPort ? `:${organization.aiPort}` : '';

  return `${env.agentIframeBaseUrl}${port}${ASK_AI_ENDPOINT}`;
};

export const useAskAiUrl = () => {
  const organizationId = useUserSetupStore(state => state.organizationId);
  const { data: organizationData } = useGetOrganization(organizationId);

  const isAiEnabled = organizationData?.aiEnabled ?? false;
  const askAiUrl = isAiEnabled ? generateAskAiUrl(organizationData) : null;

  return {
    isAiEnabled,
    askAiUrl,
    organizationData,
  };
};
